import React, {useMemo} from 'react';
import {
  Accordion as ChkrAccordion,
  AccordionItem,
  AccordionButton,
  AccordionIcon,
  AccordionPanel,
  Flex,
} from '@chakra-ui/react';
import {TopicOfInterest} from '../../../types/article';
import InterestTag from './InterestTag';
import {filterDisplayableTopics} from '../../../utils/topicFilters';

const ArticleInterestTags: React.FC<{
  interestTags: TopicOfInterest[];
  showName?: boolean;
}> = ({interestTags, showName = true}) => {
  // Filter out special topics that shouldn't be displayed to users
  const displayableTags = filterDisplayableTopics(interestTags);

  return (
    <Flex
      flexWrap="wrap"
      alignItems="flex-start"
      justifyContent="flex-start"
      gap={showName ? 2 : 1}
      w="100%">
      {displayableTags.map((item) => {
        return (
          <InterestTag
            key={item.id}
            item={item}
            icon={item.icon}
            name={showName ? item.name : ''}
          />
        );
      })}
    </Flex>
  );
};

export default ArticleInterestTags;
